import { useMutation } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import { ENTITY_VIEWS_QUERY_KEYS } from '@/api/entity-views/queries';
import { _editFundMember } from '@/api/fund/mutations';
import { FUND_QUERY_KEYS } from '@/api/fund/queries';
import { useGlobalModal } from '@/global-hooks/use-global-modal';
import { Input, Modal } from '@/shared/design-system';
import { useEntitySlice } from '@/stores/selectors';

import { queryClient } from '../providers/react-query-provider';
import { CONFIRM_MODAL_MAX_WIDTH } from './confirm-modal.constants';

export type FundJobTitleEditModalProps = { fundId: string; memberId: string; title: string };

export const FundJobTitleEditModal = () => {
  const { open, handleClose, props } = useGlobalModal('FUND_JOB_TITLE_EDIT_MODAL');

  const [title, setTitle] = useState('');

  const editBtnDisabled = title.trim().length === 0 || title.trim() === props?.title?.trim();

  const { stepForms } = useEntitySlice();
  const { mutate: editMember } = useMutation({ mutationFn: _editFundMember });

  useEffect(() => {
    if (props?.title) {
      setTitle(props.title);
    }
  }, [props?.title]);

  const handleEdit = () => {
    if (props?.fundId && props?.memberId) {
      editMember(
        { id: props.fundId, memberId: props.memberId, body: { title } },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({
              queryKey: [ENTITY_VIEWS_QUERY_KEYS.teamAssociates, stepForms.id],
            });
            queryClient.invalidateQueries({
              queryKey: [FUND_QUERY_KEYS.fundMembers, props.fundId],
            });

            handleClose();
          },
        },
      );
    }
  };

  return (
    <Modal
      open={open}
      onOpenChange={(isOpen) => !isOpen && handleClose()}
      title="Edit Job Title"
      showClose
      maxWidth={CONFIRM_MODAL_MAX_WIDTH}
      secondaryAction={{ label: 'Cancel', onClick: handleClose }}
      primaryAction={{ label: 'Save', onClick: handleEdit, disabled: editBtnDisabled }}
    >
      <Input
        size="lg"
        label="Job Title"
        placeholder="Select Another Role"
        value={title}
        onChange={(event) => setTitle(event.target.value)}
      />
    </Modal>
  );
};
